import React from 'react';
function ArrowHwIn({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 11L20 4M13 11H19M13 11V5M4 20L11 13M11 13H5M11 13V19"
      />
    </svg>
  );
}

export default ArrowHwIn;
